import env from '../env'

export default {
  reload () {
    window.location = '/'
  },
  redirectToCorp () {
    window.location = env.REACT_APP_CORP_URL
  },
  redirectToLogin () {
    const urlReturnTo = window.location.href
    const returnTo = '?returnto='
    window.location = env.REACT_APP_LOGIN_PORTAL_URL + returnTo + encodeURIComponent(urlReturnTo)
  }
}
